module.exports = __webpack_public_path__ + "static/media/help.aacfd2aa.jpg";